import { Monitor, Moon, Sun } from 'lucide-react';

import { useTheme } from '@/providers/theme-provider.jsx';

const OPTIONS = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

// Single-button theme toggle — cycles light → dark → system on click,
// shows the current mode's icon. Previously a dropdown; a cycling
// toggle is one click instead of two and the whole state space fits
// in three taps.
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const currentIdx = Math.max(
    0,
    OPTIONS.findIndex((o) => o.value === theme),
  );
  const current = OPTIONS[currentIdx];
  const next = OPTIONS[(currentIdx + 1) % OPTIONS.length];
  const ActiveIcon = current.icon;
  return (
    <button
      type="button"
      aria-label={`Theme: ${current.label}. Click to switch to ${next.label}.`}
      title={`Theme: ${current.label} → ${next.label}`}
      onClick={() => setTheme(next.value)}
      className="inline-flex h-9 w-9 items-center justify-center rounded-md text-foreground outline-none ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:ring-2 focus-visible:ring-ring"
    >
      <ActiveIcon className="h-5 w-5" />
    </button>
  );
}
